import PropTypes from 'prop-types';
import React from 'react';

const GradientLegend = ({minValue, maxValue, styleName}) => (
  <div className={`GradientLegend GradientLegend--${styleName}`} >
    <div className="GradientLegend__gradient" />
    <p className="GradientLegend__leftLabel">
      {minValue}
    </p>
    <p className="GradientLegend__rightLabel">
      {maxValue}
    </p>
  </div>
);

GradientLegend.propTypes = {
  minValue: PropTypes.string.isRequired,
  maxValue: PropTypes.string.isRequired,
  styleName: PropTypes.string.isRequired,
};

export default GradientLegend;



// WEBPACK FOOTER //
// ./src/components/GradientLegend.js